import { useMemo, useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { getCountries } from "react-phone-number-input";
import en from "react-phone-number-input/locale/en.json";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";

export const CountrySelect = ({ value, onChange, id }) => {
  const [open, setOpen] = useState(false);
  const countries = useMemo(
    () => getCountries().map((c) => en[c]).filter(Boolean).sort((a, b) => a.localeCompare(b)),
    []
  );
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button id={id} type="button" data-testid="quote-country-select" className="field flex items-center justify-between text-left" aria-haspopup="listbox">
          <span className={value ? "" : "text-muted-ink/70"}>{value || "Select your country"}</span>
          <ChevronDown size={14} className="text-wine" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[260px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search country…" data-testid="quote-country-search" />
          <CommandList className="max-h-64">
            <CommandEmpty>No country found.</CommandEmpty>
            <CommandGroup>
              {countries.map((c) => (
                <CommandItem key={c} value={c} onSelect={() => { onChange(c); setOpen(false); }} data-testid={`country-option-${c.toLowerCase().replace(/\W+/g, "-")}`}>
                  <Check size={14} className={`mr-2 ${value === c ? "opacity-100" : "opacity-0"}`} />
                  {c}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
